<template>
  <div class="main-div">
    <!-- navbar-signed-in marks the wider layout: signed in, the right group
         also carries the CountrySelector, which needs ~70px more room. -->
    <nav class="navbar" :class="{ 'navbar-signed-in': isvalid }">
     
      <div class="nav-left">
        <div class="hamburger" @click="sidebarOpen = !sidebarOpen">
          <img src="../icons/dots.svg" alt="menu" />
        </div>

        <router-link to="/" class="logo-link">
          <img src="../icons/Logo.svg" alt="Renants" class="logo logo-desktop" />
          <img src="../icons/LogoMobile.svg" alt="Renants" class="logo logo-mobile" />
        </router-link>

        
        <div class="nav-center desktop-only">
          <ul class="service-menu">
            <li
              v-for="(item, index) in serviceTypes"
              :key="index"
              @mouseenter="activeMenu = index"
              @mouseleave="activeMenu = null"
              class="menu-wrapper"
            >
              <p>{{ item.Service_type1 }}</p>

              <div
                class="more-mega service-mega"
                :class="{ 'service-mega-narrow': item.Service_type2.length <= 3 && !item.Service_type3 }"
                :style="megaStyle"
                v-if="activeMenu === index"
              >
                <div class="more-mega-header" v-if="serviceMenuMeta[item.Service_type1]?.eyebrow">
                  <span class="more-mega-eyebrow">{{ serviceMenuMeta[item.Service_type1].eyebrow }}</span>
                </div>

                <!-- Categories with a 3rd level (e.g. Real Estate): each sub-category
                     acts as a section header, and its serviceTypeInfo values render
                     as icon + label rows — the same visual language as every other
                     category's items. -->
                <template v-if="item.Service_type3">
                  <div
                    class="more-mega-section"
                    v-for="(sub, si) in item.Service_type2"
                    :key="'sec-' + si"
                  >
                    <button
                      type="button"
                      class="more-mega-section-title"
                      @click="selectSubType(sub, item.Service_type1)"
                    >{{ sub }}</button>
                    <div class="more-mega-grid">
                      <div
                        v-for="(leaf, li) in (item.Service_type3[sub] || [])"
                        :key="sub + '-' + li"
                        class="more-mega-item"
                        @click="selectLeaf(leaf, sub, item.Service_type1)"
                      >
                        <span
                          class="more-mega-icon"
                          :style="{ background: subtypeMeta(item.Service_type1, sub)?.tint || '#eef2fb', color: subtypeMeta(item.Service_type1, sub)?.accent || '#1f3987' }"
                          v-html="subtypeMeta(item.Service_type1, sub)?.iconSvg || ''"
                        ></span>
                        <div class="more-mega-text">
                          <div class="more-mega-label">{{ leaf }}</div>
                          <div class="more-mega-desc" v-if="leafBlurb(item.Service_type1, sub, leaf)">
                            {{ leafBlurb(item.Service_type1, sub, leaf) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- Standard categories: sub-categories as icon + label + blurb rows. -->
                <div
                  v-else
                  class="more-mega-grid"
                  :class="{ 'more-mega-grid-single': item.Service_type2.length <= 3 }"
                >
                  <div
                    v-for="(sub, i) in item.Service_type2"
                    :key="i"
                    class="more-mega-item"
                    @click="selectSubType(sub, item.Service_type1)"
                  >
                    <span
                      class="more-mega-icon"
                      :style="{ background: subtypeMeta(item.Service_type1, sub)?.tint || '#eef2fb', color: subtypeMeta(item.Service_type1, sub)?.accent || '#1f3987' }"
                      v-html="subtypeMeta(item.Service_type1, sub)?.iconSvg || ''"
                    ></span>
                    <div class="more-mega-text">
                      <div class="more-mega-label">{{ sub }}</div>
                      <div class="more-mega-desc" v-if="subtypeMeta(item.Service_type1, sub)?.blurb">
                        {{ subtypeMeta(item.Service_type1, sub).blurb }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <!-- More ▾ mega-dropdown — directory of third-party businesses -->
            <li
              class="menu-wrapper menu-wrapper-more"
              @mouseenter="activeMenu = 'more'"
              @mouseleave="activeMenu = null"
            >
              <p>More <span class="more-caret">▾</span></p>
              <div class="more-mega" :style="megaStyle" v-if="activeMenu === 'more'">
                <div class="more-mega-header">
                  <span class="more-mega-eyebrow">LOCAL BUSINESSES</span>
                </div>
                <div class="more-mega-grid">
                  <div
                    v-for="cat in directoryCategories"
                    :key="cat.slug"
                    class="more-mega-item"
                    @click="goToDirectory(cat.slug)"
                  >
                    <span
                      class="more-mega-icon"
                      :style="{ background: cat.tint, color: cat.accent }"
                      v-html="cat.iconSvg"
                    ></span>
                    <div class="more-mega-text">
                      <div class="more-mega-label">{{ cat.label }}</div>
                      <div class="more-mega-desc">{{ cat.blurb }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <!-- Deals — flashy top-level link to the public deals page -->
            <li class="menu-wrapper menu-wrapper-deals" @click="goToDeals">
              <span class="deals-pill">
                <svg class="deals-pill-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M12 2.5c.6 2.4-.4 3.8-1.6 5-1.4 1.4-3.1 2.9-3.1 5.6A4.8 4.8 0 0 0 12 18a4.8 4.8 0 0 0 4.7-4.9c0-1.7-.7-3-1.5-4.2-.4 1-1 1.6-1.8 2 .5-2.6-.6-5.7-1.4-8.4Z" fill="currentColor"/>
                </svg>
                <span class="deals-pill-text">Deals</span>
              </span>
            </li>
          </ul>
        </div>
            <div class="nav-message" @click="gotoMessage" title="Chat with sellers instantly">
          <div class="nav-messagetxt">
          <!-- Two faces of the same link. Wide: dot + the word "Message".
               Narrow: this bubble on its own, so the link stays reachable
               instead of dropping out of the navbar. -->
          <svg class="nav-message-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9.9 9.9 0 0 1-2.8-.4L4 21l1.4-4.1A8.2 8.2 0 0 1 3.6 11.5a8.4 8.4 0 0 1 9-8.4 8.4 8.4 0 0 1 8.4 8.4Z"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <img src="../icons/Dot.svg" alt="Message indicator" class="nav-message-dot" />
              <span class="nav-message-label">Message</span>
              <div class="nav-messagecount" v-if="totalUnreadCount > 0">
                <span>{{ totalUnreadCount }}</span>
            
            </div>
          </div>
        </div>
      </div>

      <!-- ── Unified Search Bar (AI search box hidden per request) ── -->
      <div class="nav-search desktop-only" ref="navSearchWrapper" v-if="false">
        <div class="nav-search-input-wrap">
          <span class="nav-search-ai-badge">AI</span>
          <input
            v-model="navSearchText"
            class="nav-search-input"
            type="text"
            placeholder="Search services, jobs, rentals..."
            @input="onSearchInput"
            @keydown.enter="executeSearch"
            @focus="showSearchDropdown = navSearchText.length >= 2"
            @keydown.escape="showSearchDropdown = false"
          />
          <button v-if="navSearchText" class="nav-search-clear" @click="navSearchText = ''; showSearchDropdown = false">
            &times;
          </button>
        </div>

        <div class="nav-search-dropdown" v-if="showSearchDropdown && navSearchText.length >= 2">
          <template v-if="searchSuggestions.length">
            <div class="nav-search-group-label">Categories</div>
            <div
              v-for="(item, i) in searchSuggestions"
              :key="i"
              class="nav-search-item"
              @mousedown.prevent="selectSearchSuggestion(item)"
            >
              <svg class="nav-search-item-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span>{{ item.label }}</span>
              <span class="nav-search-item-type">{{ item.typeLabel }}</span>
            </div>
          </template>
          <div
            class="nav-search-item nav-search-freetext"
            @mousedown.prevent="executeSearch"
          >
            <span class="nav-search-ai-spark">&#10024;</span>
            <span>AI Search for "<strong>{{ navSearchText }}</strong>"</span>
          </div>
        </div>
      </div>

      <div class="nav-right">
        <button class="contact-us desktop-only" @click="openContactModal" title="Get in touch with our team">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M2 7L12 13L22 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Contact</span>
        </button>

        <button class="post-btns" @click="postad">Post Free Ad</button>

        <div class="avatar-wrapper" ref="avatarWrapper" @click="toggleDropdown">
          <span class="avatar-holder">
            <img
              :src="isvalid ? ProfilePic || defaultImage : defaultImage"
              class="avatar"
              alt="User avatar"
            />
            <span
              v-if="showUpgradeDot"
              class="upgrade-dot"
              title="Upgrade options in your menu"
            ></span>
            <span
              v-if="isvalid && proPlan"
              class="pro-shield"
              :class="'pro-shield--' + proPlan"
              :title="proPlan === 'business' ? 'Business member' : 'Premium member'"
              :aria-label="proPlan === 'business' ? 'Business member' : 'Premium member'"
              role="img"
            >
              <svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true">
                <path class="pro-shield__body" d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3z" />
                <path d="m8.5 12 2.5 2.5 4.5-5" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </span>
          <span class="avatar-label desktop-only">{{ isvalid && userName ? userName.split(' ')[0] : (isvalid ? 'Account' : 'Sign In') }}</span>
          <svg class="avatar-caret desktop-only" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M2 4L5 7L8 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <ProfileDropdown
            v-if="isvalid && showDropdown"
            class="dropdown-position"
          />
        </div>

        <CountrySelector v-if="isvalid" class="hideMobile"/>
      </div>
    </nav>

    <!-- Shown when the API rejects our token. A toast rather than a modal so a
         backgrounded tab doesn't ambush the user with a dialog on return, and
         position:fixed so it stays out of the navbar's flex row — as an in-flow
         child of .main-div it shrank the nav and hid the Sign in button. -->
    <transition name="session-toast">
      <div
        v-if="sessionExpiredNotice"
        class="session-expired-toast"
        role="status"
        aria-live="polite"
      >
        <span class="session-expired-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        </span>
        <div class="session-expired-copy">
          <p class="session-expired-title">Your session has expired</p>
          <p class="session-expired-text">Sign in again to pick up where you left off.</p>
        </div>
        <button type="button" class="session-expired-signin" @click="signInAfterExpiry">
          Sign in
        </button>
        <button
          type="button"
          class="session-expired-dismiss"
          aria-label="Dismiss"
          @click="sessionExpiredNotice = false"
        >
          &times;
        </button>
      </div>
    </transition>

    <AuthModal v-if="showModal" :mode="modalMode" @close="showModal = false" @switchMode="switchMode"   @loginSuccess="handleLoginSuccess"/>
  <PostModal
  v-if="showPostModal"
  :type="postMode"
  :postId="postId"
  @close="showPostModal = false"
/>
     <ContactUsModal v-if="showContactModal" @close="showContactModal = false" />

    <div class="sidebar" :class="{ open: sidebarOpen }">
      <!-- ── Branded Header ── -->
      <div class="sidebar-header">
        <router-link to="/" class="sidebar-logo-link" @click="sidebarOpen = false">
          <img src="../icons/LogoSidebar.svg" alt="Renants" class="sidebar-logo" />
        </router-link>
        <button class="sidebar-close" @click="sidebarOpen = false" aria-label="Close menu">
          <span class="close-x">&times;</span>
        </button>
      </div>

      <!-- ── User Strip ── -->
      <div class="sidebar-user" v-if="isvalid" @click="openProfileFromSidebar">
        <img :src="ProfilePic || defaultImage" class="sidebar-avatar" alt="Profile" />
        <div class="sidebar-user-info">
          <span class="sidebar-user-name">{{ userName ? `Hi, ${userName.split(' ')[0]}` : 'My Account' }}</span>
          <span class="sidebar-user-sub">View &amp; edit profile</span>
        </div>
        <svg class="sidebar-user-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 12L10 8L6 4" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="sidebar-user sidebar-user-guest" v-else @click="sidebarOpen = false; openModal('login')">
        <div class="sidebar-guest-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="7" r="3.5" stroke="white" stroke-width="1.5"/>
            <path d="M3 17c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="sidebar-user-info">
          <span class="sidebar-user-name">Sign In / Register</span>
          <span class="sidebar-user-sub">Access your account</span>
        </div>
        <svg class="sidebar-user-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 12L10 8L6 4" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- ── Sidebar Search (AI search box hidden per request) ── -->
      <div class="sidebar-search" v-if="false">
        <input
          v-model="navSearchText"
          class="sidebar-search-input"
          type="text"
          placeholder="AI Search: try &quot;rooms Edison NJ&quot;..."
          @keydown.enter="executeSearch(); sidebarOpen = false"
        />
        <button class="sidebar-search-btn" @click="executeSearch(); sidebarOpen = false">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="white" stroke-width="2"/>
            <path d="M16.5 16.5L21 21" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <!-- ── Section Label ── -->
      <div class="sidebar-section-label">Browse Categories</div>

      <!-- ── Category Pills (like desktop filter tabs) ── -->
      <div class="sidebar-category-pills">
        <button
          v-for="(item, index) in serviceTypes"
          :key="index"
          class="sidebar-pill"
          :class="{ active: sidebarActive === index }"
          @click="toggleSidebarMenu(index)"
        >
          <!-- Rentals icon -->
          <svg v-if="item.Service_type1 === 'Rentals'" class="pill-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" stroke-width="2"/>
          </svg>
          <!-- Services icon -->
          <svg v-else-if="item.Service_type1 === 'Services'" class="pill-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <!-- Jobs icon -->
          <svg v-else-if="item.Service_type1 === 'Jobs'" class="pill-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" stroke="currentColor" stroke-width="2"/>
            <rect width="20" height="14" x="2" y="6" rx="2" stroke="currentColor" stroke-width="2"/>
          </svg>
          <!-- Sale icon -->
          <svg v-else-if="item.Service_type1 === 'Sale'" class="pill-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="8" cy="21" r="1" stroke="currentColor" stroke-width="2"/>
            <circle cx="19" cy="21" r="1" stroke="currentColor" stroke-width="2"/>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <!-- Events icon -->
          <svg v-else-if="item.Service_type1 === 'Events'" class="pill-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M8 2v4M16 2v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <rect width="18" height="18" x="3" y="4" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M3 10h18" stroke="currentColor" stroke-width="2"/>
          </svg>
          <!-- Real Estate icon -->
          <svg v-else-if="item.Service_type1 === 'Real Estate'" class="pill-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M3 21h18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M5 21V8l7-5 7 5v13" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
            <path d="M9 21v-6h6v6" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
          </svg>
          {{ item.Service_type1 }}
        </button>
      </div>

      <!-- ── Submenu for selected category ── -->
      <ul v-if="sidebarActive !== null && sidebarActive !== 'more'" class="sidebar-submenu-list">
        <template v-for="(sub, i) in serviceTypes[sidebarActive]?.Service_type2" :key="i">
          <li
            @click="selectSubType(sub, serviceTypes[sidebarActive]?.Service_type1)"
            class="sidebar-submenu-item"
          >
            <svg class="submenu-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="2" fill="currentColor"/>
            </svg>
            {{ sub }}
            <svg class="submenu-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
          <!-- 3rd-level leaves (serviceTypeInfo) nested under the sub-category -->
          <li
            v-for="(leaf, li) in (serviceTypes[sidebarActive]?.Service_type3 || {})[sub] || []"
            :key="sub + '-' + li"
            @click="selectLeaf(leaf, sub, serviceTypes[sidebarActive]?.Service_type1)"
            class="sidebar-submenu-item sidebar-submenu-leaf"
          >
            {{ leaf }}
          </li>
        </template>
      </ul>

      <!-- ── Deals — splash card ── -->
      <div class="sidebar-deals-card" @click="goToDeals(); sidebarOpen = false">
        <span class="sidebar-deals-shine" aria-hidden="true"></span>
        <span class="sidebar-deals-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M12 2.5c.6 2.4-.4 3.8-1.6 5-1.4 1.4-3.1 2.9-3.1 5.6A4.8 4.8 0 0 0 12 18a4.8 4.8 0 0 0 4.7-4.9c0-1.7-.7-3-1.5-4.2-.4 1-1 1.6-1.8 2 .5-2.6-.6-5.7-1.4-8.4Z" fill="currentColor"/>
          </svg>
        </span>
        <div class="sidebar-deals-text">
          <div class="sidebar-deals-title">Deals &amp; Offers</div>
          <div class="sidebar-deals-desc">Hot deals from local businesses</div>
        </div>
        <svg class="sidebar-deals-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- ── More: directory categories ── -->
      <div class="sidebar-section-label sidebar-more-label">More — Local Businesses</div>
      <ul class="sidebar-submenu-list">
        <li
          v-for="cat in directoryCategories"
          :key="cat.slug"
          @click="goToDirectory(cat.slug); sidebarOpen = false"
          class="sidebar-submenu-item sidebar-more-item"
        >
          <span
            class="sidebar-more-icon"
            :style="{ background: cat.tint, color: cat.accent }"
            v-html="cat.iconSvg"
          ></span>
          <div class="sidebar-more-text">
            <div class="sidebar-more-itemlabel">{{ cat.label }}</div>
            <div class="sidebar-more-itemdesc">{{ cat.blurb }}</div>
          </div>
          <svg class="submenu-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </li>
      </ul>

      <!-- ── Bottom Actions ── -->
      <div class="sidebar-actions">
        <button class="sidebar-action-btn sidebar-action-message" @click="sidebarOpen = false; gotoMessage()">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path d="M14.5 2.5H2.5C1.67 2.5 1 3.17 1 4V12C1 12.83 1.67 13.5 2.5 13.5H5.5L8.5 16.5L11.5 13.5H14.5C15.33 13.5 16 12.83 16 12V4C16 3.17 15.33 2.5 14.5 2.5Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
          </svg>
          Messages
          <span class="sidebar-msg-badge" v-if="totalUnreadCount > 0">{{ totalUnreadCount }}</span>
        </button>
        <button class="sidebar-action-btn sidebar-action-contact" @click="sidebarOpen = false; openContactModal()">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path d="M8.5 1C4.36 1 1 4.36 1 8.5C1 12.64 4.36 16 8.5 16C12.64 16 16 12.64 16 8.5C16 4.36 12.64 1 8.5 1ZM8.5 13C8.09 13 7.75 12.66 7.75 12.25V8.5C7.75 8.09 8.09 7.75 8.5 7.75C8.91 7.75 9.25 8.09 9.25 8.5V12.25C9.25 12.66 8.91 13 8.5 13ZM8.5 6.5C8.09 6.5 7.75 6.16 7.75 5.75C7.75 5.34 8.09 5 8.5 5C8.91 5 9.25 5.34 9.25 5.75C9.25 6.16 8.91 6.5 8.5 6.5Z" fill="currentColor"/>
          </svg>
          Contact Us
        </button>
      </div>
    </div>

    <div v-if="sidebarOpen" class="overlay" @click="sidebarOpen = false"></div>
  </div>
</template>

<script>
import LoginModal from "./Models/LoginModal.vue";
import axios from "axios";
import serviceType from "./servicesType.json";
import { matchServiceTypes } from "../../utils/serviceTypeMatcher.js";
import { DIRECTORY_CATEGORIES } from "../../config/directoryCategories.js";
import { SERVICE_MENU_META, getSubtypeMeta, getLeafBlurb } from "../../config/serviceMenuMeta.js";
import { EventBus } from "../../services/EventBus.js";
import ProfileDropdown from "./ProfileDropdown.vue";
import { useSubscription, fetchSubscriptionStatus } from "@/composables/useSubscription";
import CountrySelector from "./CountrySelector.vue";
import defaultImage from "../icons/Avatar.svg";
import AuthModal from "../pages/Models/AuthModal.vue";
import PostModal from "./Models/PostModal.vue";
import ContactUsModal from "../pages/Models/contactUs.vue";
import userDetailsServices from "../../services/userDetailsService.js";
import { trackInteraction } from "../../utils/trackInteraction.js";
import { resetSessionExpiry } from "../../utils/sessionExpiry.js";
import { connectSocket } from "../../utils/socketClient.js";
import { startMessageNotifications } from "../../utils/messageNotifier.js";
;
import { nextTick, watch } from "vue";
import { toast } from "vue-sonner";

// Categories kept out of the nav (top pills + mega menu + mobile sidebar) while
// still being valid everywhere else — filters, posting, /:subtype/:city URLs.
const HIDDEN_NAV_CATEGORIES = ["Real Estate"];

const UPGRADE_DOT_KEY = "upgradeDotSeenAt";
const UPGRADE_DOT_SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;
function readUpgradeDotSeenAt() {
  try {
    return Number(localStorage.getItem(UPGRADE_DOT_KEY)) || 0;
  } catch (e) {
    return 0;
  }
}

export default {
  components: { LoginModal, ProfileDropdown, CountrySelector, AuthModal, ContactUsModal ,PostModal},

  data() {
    return {
      showLogin: false,
      isvalid: null,
      unreadCounts: {},
      userid: localStorage.getItem("userid"),
      userName: localStorage.getItem("username") || "",
      serviceTypes: serviceType.service_types.filter(
        (t) => !HIDDEN_NAV_CATEGORIES.includes(t.Service_type1)
      ),
      directoryCategories: DIRECTORY_CATEGORIES,
      serviceMenuMeta: SERVICE_MENU_META,
      activeMenu: null,
      // Horizontal correction applied to the open mega panel so it can never
      // be clipped by the viewport edge — see clampMegaPanel().
      megaShift: 0,
      showDropdown: false,
      defaultImage: defaultImage,
      ProfilePic: null,
      showModal: false,
      modalMode: "login",
         showPostModal: false,
    postMode: "new", 
      showContactModal: false,
      previousUnreadTotal: 0,
      sidebarOpen: false,
      sidebarActive: null,
      // ── Search bar state ──
      navSearchText: "",
      showSearchDropdown: false,
      searchSuggestions: [],
      searchDebounceTimer: null,
      // Unread-count poller handle; null whenever polling is stopped.
      unreadPollTimer: null,
      sessionExpiredNotice: false,
      upgradeDotSeenAt: readUpgradeDotSeenAt(),
    };
  },


  created() {
    this.fetchUnreadCounts();
    this.startUnreadPolling();

    // Stop polling the moment the session dies. Without this the interval keeps
    // firing against an expired token indefinitely (see utils/sessionExpiry.js).
    window.addEventListener("session-expired", this.handleSessionExpiredEvent);
    // Background tabs shouldn't poll at all — an idle tab left open overnight
    // otherwise generates hundreds of pointless requests an hour.
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },


  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
    window.removeEventListener("resize", this.handleViewportResize);
    document.removeEventListener("click", this.handleSearchOutsideClick);
    // The interval used to outlive the component, so a remount stacked a second
    // poller on top of the first.
    this.stopUnreadPolling();
    window.removeEventListener("session-expired", this.handleSessionExpiredEvent);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
    window.addEventListener("resize", this.handleViewportResize);
    // Search bar outside-click handler
    document.addEventListener("click", this.handleSearchOutsideClick);

    // Check if returning from Stripe callback with missing token
    const params = new URLSearchParams(window.location.search);
    const fromStripe = params.has("subscription");
    
    const checkToken = () => {
      const token = localStorage.getItem("auth-token");

      // If we have a token, verify it with the backend (with proper timeout handling)
      if (token) {
        console.log("[Navigation] Found auth-token");
        axios
          .post(
            "/api/verify-token",
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
              withCredentials: true,
              timeout: 5000, // 5 second timeout - shorter to not block UI
            }
          )
          .then(() => {
            console.log("[Navigation] Token verified ✓");
            this.isvalid = true;
            this.userName = localStorage.getItem("username") || "";
            if (!this.userName) this.restoreUserName();
            this.fetchUnreadCounts();
          })
          .catch((err) => {
            // Check if it's a real 401 auth error vs network/timeout
            if (err.response?.status === 401) {
              console.warn("[Navigation] Token invalid (401)", err.response.data);
              this.isvalid = false;
            } else {
              // Network timeout, server error, etc - keep user logged in
              // This prevents logout when coming back from Stripe or on slow networks
              console.log("[Navigation] Token verification delayed, keeping session:", {
                status: err.response?.status,
                message: err.message,
              });
              this.isvalid = true;
              this.userName = localStorage.getItem("username") || "";
              // Don't block on unread counts if network is slow
              setTimeout(() => this.fetchUnreadCounts(), 500);
            }
          });
      } else {
        // Token not found
        if (fromStripe) {
          // Coming from Stripe but no token - wait a moment and retry
          console.log("[Navigation] Returning from Stripe but token missing, retrying in 500ms...");
          setTimeout(checkToken, 500);
        } else {
          console.log("[Navigation] No token in localStorage");
          this.isvalid = false;
        }
      }
    };
    
    // Initial check
    checkToken();
    
    // Preload profile image (non-blocking)
    const userId = localStorage.getItem("userid");
    if (userId) {
      userDetailsServices.getProfileImage(userId).then((imgUrl) => {
        this.ProfilePic = imgUrl || defaultImage;
      });
    }
    
    // Load Google Analytics (non-blocking)
    this.loadGoogleAnalytics().then(() => {
      if (import.meta.env.DEV) {
        console.log("Google Analytics initialized");
      }
    });

    // Watch for message read events from MessageSection
    watch(() => EventBus.messageReadRefresh, () => {
      console.log('[Navigation] Refresh unread counts');
      this.fetchUnreadCounts();
    });

    // Watch for global login success event
    watch(
      () => EventBus.globalLoginSuccess,
      () => {
        this.handleLoginSuccess();
      }
    );

    // Watch for "Post Free Ad" requests from other pages (e.g. Why Renants CTA)
    watch(
      () => EventBus.postAdRequest,
      () => {
        this.postad();
      }
    );
  },

  watch: {
    // Every mega panel is a fixed-width box anchored to its own <li> with a
    // hard-coded left:0 / right:0, so whether it fits depends on where that
    // trigger happens to land — which moves with viewport width, browser zoom
    // and whether the CountrySelector is in the row. When it doesn't fit,
    // App.vue's `html, body { overflow-x: hidden }` clips the overflow instead
    // of scrolling it, so the panel is silently cut off. Re-measure on open and
    // nudge it back inside.
    activeMenu(open) {
      if (open === null || open === undefined) {
        this.megaShift = 0;
        return;
      }
      // Measure the panel where CSS put it, then correct.
      this.megaShift = 0;
      this.$nextTick(this.clampMegaPanel);
    },
    // Load the plan whenever the user becomes signed in (page load, login,
    // session restore) so the avatar can show the Premium/Business shield.
    isvalid(signedIn) {
      if (signedIn) fetchSubscriptionStatus();
    },
  },

  computed: {
    // "premium" | "business" for paying users, null otherwise. The plan ref is
    // shared app-wide, so an upgrade on the Pricing page updates this live.
    proPlan() {
      const plan = useSubscription().currentPlan.value;
      return plan === "premium" || plan === "business" ? plan : null;
    },
    // Small gold dot on a Free user's avatar pointing at the plan card in the
    // menu. Waits for the status call (no flash for paid users) and stays
    // hidden for a while after the menu has been opened.
    showUpgradeDot() {
      const { subscription, currentPlan } = useSubscription();
      if (!this.isvalid || !subscription.value || currentPlan.value !== "free") return false;
      return Date.now() - this.upgradeDotSeenAt > UPGRADE_DOT_SNOOZE_MS;
    },

    // Applied to whichever mega panel is open. Kept as a transform rather than
    // a `left` override so the panel's own left/right anchoring stays intact
    // and only the correction moves.
    megaStyle() {
      return this.megaShift ? { transform: `translateX(${this.megaShift}px)` } : null;
    },

    totalUnreadCount() {
      if (!this.isvalid) return 0;
      return Object.values(this.unreadCounts).reduce(
        (sum, count) => sum + count,
        0
      );
    },
  },

  methods: {
    // Shift the open mega panel horizontally so it sits fully inside the
    // viewport. Reads the panel from the DOM rather than a ref because only one
    // is ever rendered (v-if on activeMenu) and refs inside v-for are arrays.
    clampMegaPanel() {
      const panel = this.$el && this.$el.querySelector && this.$el.querySelector(".more-mega");
      if (!panel) return;

      const GUTTER = 12;
      // clientWidth, not innerWidth — innerWidth includes the scrollbar gutter,
      // which would let the panel sit under it.
      const viewport = document.documentElement.clientWidth;
      const rect = panel.getBoundingClientRect();
      // Where the panel would sit with no correction; rect already carries the
      // current shift when this runs from the resize handler.
      const left = rect.left - this.megaShift;

      let shift = 0;
      if (left + rect.width > viewport - GUTTER) {
        shift = viewport - GUTTER - (left + rect.width);
      }
      // A panel wider than the viewport can't satisfy both edges — favour the
      // left one so the panel starts where the reader does.
      if (left + shift < GUTTER) shift = GUTTER - left;

      this.megaShift = Math.round(shift);
    },

    // Zooming fires resize, which is exactly the case that used to strand a
    // panel half off-screen while it was open.
    handleViewportResize() {
      if (this.activeMenu === null || this.activeMenu === undefined) return;
      this.clampMegaPanel();
    },

    subtypeMeta(category, subtype) {
      return getSubtypeMeta(category, subtype);
    },
    leafBlurb(category, subtype, leaf) {
      return getLeafBlurb(category, subtype, leaf);
    },
    // ── Search bar methods ────────────────────────────────────────────────
    handleSearchOutsideClick(e) {
      const wrap = this.$refs.navSearchWrapper;
      if (wrap && !wrap.contains(e.target)) {
        this.showSearchDropdown = false;
      }
    },

    onSearchInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        const q = this.navSearchText.trim();
        if (q.length < 2) {
          this.searchSuggestions = [];
          this.showSearchDropdown = false;
          return;
        }

        // Client-side match against service types (shared with the hero "What" field)
        this.searchSuggestions = matchServiceTypes(q);
        this.showSearchDropdown = true;
      }, 200);
    },

    executeSearch() {
      const q = this.navSearchText.trim();
      if (!q) return;
      trackInteraction('search', 'ai-search', { label: q, role: this.isvalid ? 'user' : 'guest', extra: { source: 'navbar', mode: 'ai' } });
      EventBus.setSearchQuery(q);
      this.showSearchDropdown = false;
      this.navSearchText = "";
      // Navigate to dashboard and scroll to results
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.scrollToResults();
    },

    // Smoothly scroll the page down to the results section.
    // Retries briefly so it also works right after a route change,
    // when the results container is still mounting.
    scrollToResults() {
      let attempts = 0;
      const tryScroll = () => {
        const el = document.querySelector(".grid-container, .main-section");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempts++ < 20) {
          setTimeout(tryScroll, 100);
        }
      };
      this.$nextTick(tryScroll);
    },

    selectSearchSuggestion(item) {
      this.showSearchDropdown = false;
      this.navSearchText = "";
      EventBus.clearSearchQuery();
      if (item.type === "type1") {
        EventBus.setServiceType(item.value);
      } else {
        EventBus.setSubtype(item.value);
      }
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },

async handleLoginSuccess(service) {
  this.showModal = false;

  const token = localStorage.getItem("auth-token");

  if (!token) {
    this.isvalid = false;
    return;
  }

  try {
    await axios.post(
      "/api/verify-token",
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      }
    );

    this.isvalid = true;
    this.userid = localStorage.getItem("userid");
    this.userName = localStorage.getItem("username") || "";
    // Re-arm the expiry guard and resume polling for the new session.
    resetSessionExpiry();
    // Come online straight away — logging in from the modal doesn't navigate,
    // so nothing else would open the socket until the next route change.
    connectSocket();
    startMessageNotifications();
    this.sessionExpiredNotice = false;
    this.fetchUnreadCounts();
    this.startUnreadPolling();

    // Also reload profile image after login
    const userId = localStorage.getItem("userid");
    userDetailsServices.getProfileImage(userId).then((imgUrl) => {
      this.ProfilePic = imgUrl || this.defaultImage;
    });

  } catch (error) {
    this.isvalid = false;
  }
},

     handleOutsideClick(event) {
      const wrapper = this.$refs.avatarWrapper;
      if (wrapper && !wrapper.contains(event.target)) {
        this.showDropdown = false;
      }
    },
    toggleSidebarMenu(index) {
      this.sidebarActive = this.sidebarActive === index ? null : index;
    },
    loadGoogleAnalytics() {
      const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
      if (!gaId) {
        if (import.meta.env.DEV) console.warn('Google Analytics ID not configured');
        return Promise.resolve();
      }
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script);

      return new Promise((resolve, reject) => {
        script.onload = () => {
          window.dataLayer = window.dataLayer || [];
          window.gtag = (...args) => {
            window.dataLayer.push(
              args);
          };
          window.gtag("js", new Date());
          window.gtag("config", gaId);
          this.isAnalyticsLoaded = true;
          resolve();
        };

        script.onerror = () => {
          // console.error("Failed to load Google Analytics script.");
          // reject(new Error("Google Analytics script failed to load"));
        };
      });
    },
    openModal(type) {
      this.modalMode = type;
      this.showModal = true;
    },
    switchMode(type) {
      this.modalMode = type;
    },
    openProfileFromSidebar() {
      // Mobile menu counterpart of the desktop avatar → profile click.
      trackInteraction('navbar', 'profile-menu', { label: 'sidebar-profile', role: 'user' });
      this.sidebarOpen = false;
      this.$router.push('/profile');
    },
    toggleDropdown() {
      // Count opens only — a click that closes the menu isn't a new visit.
      if (!this.isvalid || !this.showDropdown) {
        trackInteraction('navbar', 'profile', { role: this.isvalid ? 'user' : 'guest' });
      }
      if (this.isvalid) {
        // Deliberately no stopPropagation. It used to swallow the click — off
        // the implicit global `event`, no less — before it could reach
        // document, so every OTHER open dropdown's outside-click handler was
        // never told about it. That is why opening the profile menu left the
        // CountrySelector's list open behind it. handleOutsideClick below
        // already ignores clicks inside avatarWrapper, so letting this one
        // bubble does not re-close the menu we are opening.
        this.showDropdown = !this.showDropdown;
        if (this.showUpgradeDot) {
          // They've seen the plan card now — snooze the dot.
          this.upgradeDotSeenAt = Date.now();
          try { localStorage.setItem(UPGRADE_DOT_KEY, String(this.upgradeDotSeenAt)); } catch (e) { /* storage blocked */ }
        }
      } else {
        this.openModal("login");
        localStorage.setItem("redirectTo", "/");
      }
    },
    openContactModal() {
      trackInteraction('navbar', 'contact', { role: this.isvalid ? 'user' : 'guest' });
      this.showContactModal = true;
    },


postad() {
  trackInteraction('navbar', 'post-free-ad', { role: this.isvalid ? 'user' : 'guest' });
  if (!this.isvalid) {
    localStorage.setItem("redirectTo", this.$route.fullPath); 
    this.modalMode = "login";
    this.showModal = true;
  } else {
    this.postMode = "new";
    this.showPostModal = true;
  }
},




    gotoMessage() {
      trackInteraction('navbar', 'message', { role: this.isvalid ? 'user' : 'guest' });
      if (this.isvalid) {
        // SPA navigation, not window.location: a full reload fires Views'
        // beforeunload → clearSessionState(), wiping dashboardState and the
        // EventBus, so Back from Messages lost the hero/advanced-search location.
        this.$router.push("/messages");
      } else {
        localStorage.setItem("redirectTo", "/messages");

        this.openModal("login");
      }
    },
    // selectSubType(sub) {
    //   this.activeMenu = null;  
    //   EventBus.setSubtype(sub);
    //   if (this.$route.path !== "/dashboard") {
    //       EventBus.markNavigation();
    //         EventBus.userInteracted = true;
    //     this.$router.push("/dashboard").then(() => {
    //       window.scrollTo({ top: 600, behavior: "smooth" });
    //     });
    //   } else {
    //     window.scrollTo({ top: 600, behavior: "smooth" });
    //   }
    // },
// selectSubType(sub) {
//   this.activeMenu = null;

//   // ✅ force reactive change
//   EventBus.selectedSubtype = "";

//   this.$nextTick(() => {
//     EventBus.setSubtype(sub);
//     EventBus.userInteracted = true;

//     if (this.$route.path !== "/") {
//       EventBus.markNavigation();
//       this.$router.push("/").then(() => {
//         window.scrollTo({ top: 600, behavior: "smooth" });
//       });
//     } else {
//       window.scrollTo({ top: 600, behavior: "smooth" });
//     }
//   });
// },
  goToDirectory(slug) {
      trackInteraction('navbar', 'directory-category', { label: slug, role: this.isvalid ? 'user' : 'guest' });
      // Convert API slug (real_estate) to URL slug (real-estate)
      const urlSlug = String(slug).replace(/_/g, "-");
      this.activeMenu = null;
      this.sidebarActive = null;
      this.sidebarOpen = false;
      EventBus.clearSearchQuery();
      this.navSearchText = "";
      this.$router.push(`/more/${urlSlug}`);
    },

    goToDeals() {
      trackInteraction('navbar', 'deals', { role: this.isvalid ? 'user' : 'guest' });
      this.activeMenu = null;
      this.sidebarActive = null;
      this.sidebarOpen = false;
      EventBus.clearSearchQuery();
      this.navSearchText = "";
      if (this.$route.path !== "/deals") this.$router.push("/deals");
    },

    selectSubType(sub, parentCategory) {
      // Record the sub-category (e.g. "Offer a Room") plus its parent service
      // category (Rentals / Jobs / Sale / Events / Services) when we know it.
      trackInteraction('navbar', 'service-menu', {
        label: parentCategory ? `${parentCategory} › ${sub}` : sub,
        role: this.isvalid ? 'user' : 'guest',
        extra: parentCategory ? { category: parentCategory, subtype: sub } : { subtype: sub },
      });
      this.activeMenu = null;
      this.sidebarActive = null;
      this.sidebarOpen = false;
      // Clear AI search so normal filtering takes over
      EventBus.clearSearchQuery();
      this.navSearchText = "";
      // ✅ force reactive change
      EventBus.selectedSubtype = "";
      this.$nextTick(() => {
        EventBus.setSubtype(sub);
        EventBus.userInteracted = true;
        // Always go to dashboard on mobile sidebar selection
        if (this.$route.path !== "/") {
          EventBus.markNavigation();
          this.$router.push("/").then(() => this.scrollToResults());
        } else {
          // Already on dashboard — scroll to results after they re-filter.
          this.scrollToResults();
        }
      });
    },

    // 3rd-level leaf click (e.g. "Single Family Homes" under Real Estate ›
    // Residential Properties). Scopes the dashboard to the exact serviceTypeInfo
    // value. Mirrors selectSubType but routes through EventBus.setServiceInfo.
    selectLeaf(leaf, parentSub, parentCategory) {
      trackInteraction('navbar', 'service-menu', {
        label: parentCategory ? `${parentCategory} › ${parentSub} › ${leaf}` : leaf,
        role: this.isvalid ? 'user' : 'guest',
        extra: { category: parentCategory, subtype: parentSub, serviceInfo: leaf },
      });
      this.activeMenu = null;
      this.sidebarActive = null;
      this.sidebarOpen = false;
      // Clear AI search so normal filtering takes over
      EventBus.clearSearchQuery();
      this.navSearchText = "";
      // ✅ force reactive change
      EventBus.selectedServiceInfo = "";
      this.$nextTick(() => {
        EventBus.setServiceInfo(leaf);
        EventBus.userInteracted = true;
        if (this.$route.path !== "/") {
          EventBus.markNavigation();
          this.$router.push("/").then(() => this.scrollToResults());
        } else {
          this.scrollToResults();
        }
      });
    },

    startUnreadPolling() {
      if (this.unreadPollTimer) return;           // never stack intervals
      if (import.meta.env.VITE_MESSAGE_POLL_ENABLED === 'false') return;
      if (!this.userid) return;                   // nothing to poll for when signed out

      const pollInterval = import.meta.env.VITE_UNREAD_POLL_INTERVAL || 5000;
      this.unreadPollTimer = setInterval(() => {
        this.fetchUnreadCounts();
      }, pollInterval);
    },

    stopUnreadPolling() {
      if (!this.unreadPollTimer) return;
      clearInterval(this.unreadPollTimer);
      this.unreadPollTimer = null;
    },

    handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
        this.stopUnreadPolling();
      } else {
        // Catch up immediately, then resume the interval.
        this.fetchUnreadCounts();
        this.startUnreadPolling();
      }
    },

    handleSessionExpiredEvent() {
      this.stopUnreadPolling();
      // sessionExpiry.js has already cleared localStorage; mirror that in local
      // state so the nav renders as signed-out and the badge clears.
      this.userid = null;
      this.userName = "";
      this.isvalid = false;
      this.unreadCounts = {};
      this.ProfilePic = null;
      this.sessionExpiredNotice = true;
    },

    signInAfterExpiry() {
      this.sessionExpiredNotice = false;
      this.modalMode = "login";
      this.showModal = true;
    },

    // Some sign-in paths (email login link, older sessions) never stored the
    // display name, leaving the nav on "Account". Recover it from the user's
    // own record (the token is attached, so /getoneusers returns full fields).
    async restoreUserName() {
      const userID = localStorage.getItem("userid");
      if (!userID) return;
      try {
        const res = await axios.post("/api/getoneusers", { userID });
        const name = res.data?.[0]?.userName;
        if (name) {
          localStorage.setItem("username", name);
          this.userName = name;
        }
      } catch (e) {
        /* keep the "Account" fallback */
      }
    },

    fetchUnreadCounts() {
      if (!this.userid) return;
      userDetailsServices
        .fetchUnreadCounts(this.userid)
        .then((res) => {
          const unreadMessages = res?.data?.items || [];

          console.log('[Navigation fetchUnreadCounts] Received from API:', {
            totalCount: unreadMessages.length,
            messages: unreadMessages.map(m => ({
              from: m.fromUserId,
              text: m.message?.substring(0, 20)
            }))
          });

          this.unreadCounts = unreadMessages.reduce((counts, message) => {
            const sender = message.fromUserId;
            counts[sender] = (counts[sender] || 0) + 1;
            return counts;
          }, {});

          console.log('[Navigation fetchUnreadCounts] Updated unreadCounts:', this.unreadCounts);
          console.log('[Navigation fetchUnreadCounts] Total unread:', this.totalUnreadCount);
        })
        .catch((err) => console.error("Error fetching unread", err.message || err));
    },
  },
};
</script>

<style scoped>
/* ══════════════════════════════════════════════════════
   SESSION EXPIRED NOTICE
══════════════════════════════════════════════════════ */
/* Fixed, so it never participates in .main-div's 76px flex row. Sits just
   below the sticky navbar (z-index 5000) without covering it. */
.session-expired-toast {
  position: fixed;
  top: calc(88px + env(safe-area-inset-top, 0px));
  right: 24px;
  z-index: 4999;
  display: flex;
  align-items: center;
  gap: 14px;
  max-width: 440px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(52, 103, 213, 0.14);
  border-left: 4px solid #e8952f;
  box-shadow: 0 12px 32px rgba(15, 30, 60, 0.16);
  color: #1f2a3d;
  font-size: 14px;
}

.session-expired-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #fff4e5;
  color: #b26a00;
}

.session-expired-icon svg {
  width: 18px;
  height: 18px;
  display: block;
}

.session-expired-copy {
  min-width: 0;
}

.session-expired-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #14213d;
}

.session-expired-text {
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #5b6880;
}

.session-expired-signin {
  flex-shrink: 0;
  border: none;
  background: #3467d5;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.session-expired-signin:hover {
  background: #2a55b4;
  box-shadow: 0 4px 12px rgba(52, 103, 213, 0.28);
}

.session-expired-signin:focus-visible {
  outline: 2px solid #3467d5;
  outline-offset: 2px;
}

.session-expired-dismiss {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #8b95a7;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
  border-radius: 6px;
}

.session-expired-dismiss:hover {
  color: #3c4759;
}

.session-toast-enter-active,
.session-toast-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.session-toast-enter-from,
.session-toast-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* ══════════════════════════════════════════════════════
   NAVBAR WRAPPER
══════════════════════════════════════════════════════ */
.main-div {
  width: 100%;
  /* Safe-area padding keeps the nav below the notch/status bar in the native
     app (viewport-fit=cover); env() is 0 in ordinary browsers. */
  height: calc(76px + env(safe-area-inset-top, 0px));
  padding-top: env(safe-area-inset-top, 0px);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  background-image: linear-gradient(180deg, #f1f4f8 0%, #ffffff 100%);
  border-bottom: 1px solid rgba(52, 103, 213, 0.12);
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 5000;
}

.navbar {
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;        /* never allow items to wrap to a 2nd line */
  column-gap: 16px;         /* floor on the space-between gap, so the left
                               group (…Message) can never sit flush against
                               the right group (Contact…) */
  width: 100%;
  max-width: 1600px;        /* widened from 1440 — at the old cap the
                               logged-in right group (avatar+name +
                               CountrySelector) plus Contact + Message
                               could not fit even on 1920px monitors. */
  padding-left: 48px;
  padding-right: 48px;
  height: 100%;
}

/* ── Left ── */
.nav-left {
  display: flex;
  align-items: center;
  gap: 20px;
  min-width: 0;
  flex-shrink: 0;           /* never shrink logo + menu links */
}

.logo {
  width: 240px;
  height: 56px;
  flex-shrink: 0;
}
.logo-mobile { display: none; }

/* ── Center nav links ── */
.nav-center {
  display: flex;
  gap: 4px;
  position: relative;
  align-items: center;
}

.service-menu {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0;
  margin: 0;
}

.service-menu > li {
  position: relative;
  cursor: pointer;
}

.service-menu > li > p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  padding: 6px 12px;
  border-radius: 6px;
  transition: background 0.18s, color 0.18s;
  position: relative;
}

.service-menu > li > p::after {
  content: "";
  display: block;
  height: 2px;
  border-radius: 2px;
  background: var(--primary-color, #3467d5);
  width: 0;
  transition: width 0.22s ease;
  position: absolute;
  bottom: 4px;
  left: 14px;
}

.service-menu > li:hover > p {
  color: var(--primary-color, #3467d5);
  background: #f0f4ff;
}

.service-menu > li:hover > p::after {
  width: calc(100% - 28px);
}

/* Dropdown submenu */
.submenu {
  list-style: none;
  position: absolute;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10);
  top: calc(100% + 6px);
  left: 0;
  padding: 6px 0;
  min-width: 180px;
  border-radius: 10px;
  z-index: 1000;
}

/* Invisible bridge to prevent dropdown from closing when moving mouse */
.submenu::before {
  content: "";
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  height: 12px;
  background: transparent;
}

.submenu li {
  padding: 9px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 450;
  color: #374151;
  font-family: "Inter", sans-serif;
  transition: background 0.15s, color 0.15s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.submenu li:hover {
  background: #f0f4ff;
  color: var(--primary-color, #3467d5);
}

/* ── Message pill ── */
.nav-message {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f0f4ff;
  border: 1.5px solid rgba(52, 103, 213, 0.18);
  border-radius: 20px;
  padding: 5px 14px 5px 10px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
  margin-left: 4px;
}

.nav-message:hover {
  background: #dce6ff;
  border-color: rgba(52, 103, 213, 0.35);
}

.nav-messagetxt {
  display: flex;
  align-items: center;
  gap: 7px;
}

.nav-messagetxt img {
  width: 8px;
  height: 8px;
  display: inline-block;
}

.nav-messagetxt span {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color, #3467d5);
  line-height: 1;
}

.nav-messagecount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: #3467d5;
  border-radius: 9px;
  margin-left: 4px;
}

.nav-messagecount span {
  font-family: "Inter", sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  text-align: center;
}

/* ── Right ── */
.nav-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
  min-width: 0;
}

.contact-us {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1.5px solid #e2e8f0;
  border-radius: 20px;
  margin: 0;
  padding: 6px 14px 6px 12px;
  font-size: 13px;
  font-family: "Inter", sans-serif;
  color: #475569;
  cursor: pointer;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
  text-decoration: none;
}

.contact-us svg {
  flex-shrink: 0;
  color: #64748b;
  transition: color 0.2s;
  margin-right: 2px;
}

.contact-us:hover {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: rgba(52, 103, 213, 0.35);
  color: var(--primary-color, #3467d5);
  box-shadow: 0 2px 8px rgba(52, 103, 213, 0.12);
}

.contact-us:hover svg {
  color: var(--primary-color, #3467d5);
}

.post-btns {
  background: var(--primary-gradient, linear-gradient(90deg, #0134a2, #012779, #3467d5));
  color: #ffffff;
  border: none;
  padding: 8px 18px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1;
  height: 36px;
  border-radius: 6px;
  white-space: nowrap;
  box-shadow: 0 2px 10px rgba(52, 103, 213, 0.30);
  letter-spacing: 0.01em;
}

.post-btns:hover {
  opacity: 0.92;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(52, 103, 213, 0.40);
}

.avatar-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 10px 4px 4px;
  border-radius: 20px;
  transition: background 0.2s;
}

.avatar-wrapper:hover {
  background: #f0f4ff;
}

.avatar-wrapper img {
  border-radius: 50%;
  border: 2px solid #e5e7eb;
  transition: border-color 0.2s;
}

.avatar-wrapper:hover img {
  border-color: var(--primary-color, #3467d5);
}

.avatar-label {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.avatar-caret {
  color: #6b7280;
  transition: transform 0.2s;
}

.avatar-wrapper:hover .avatar-caret {
  color: var(--primary-color, #3467d5);
}

.dropdown-position {
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 2000;
}

.avatar {
  height: 34px;
  width: 34px;
  border-radius: 50%;
}

/* Premium/Business shield overlaid on the avatar's bottom-right corner */
.avatar-holder {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}
.pro-shield {
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: 17px;
  height: 17px;
  pointer-events: auto;
  filter: drop-shadow(0 0 1px #fff) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25));
}
.pro-shield svg { display: block; }
.upgrade-dot {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #f5a623;
  border: 2px solid #fff;
  box-sizing: border-box;
}
.pro-shield--premium .pro-shield__body { fill: #f5a623; }
.pro-shield--business .pro-shield__body { fill: #6d4ae8; }

/* ══════════════════════════════════════════════════════
   SIDEBAR
══════════════════════════════════════════════════════ */
.sidebar {
  position: fixed;
  left: -300px;
  top: 0;
  width: 300px;
  height: 100vh;
  height: 100dvh; /* track the real visual viewport on phones */
  background: #ffffff;
  padding: 0;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9999;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 6px 0 32px rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
}

.sidebar.open {
  left: 0;
}

/* ── Sidebar Header ── */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* The sidebar starts at y=0, so its header clears the notch itself */
  padding: env(safe-area-inset-top, 0px) 18px 0;
  height: calc(60px + env(safe-area-inset-top, 0px));
  background: linear-gradient(135deg, #1d3fa8 0%, #3467d5 60%, #5b87f0 100%);
  flex-shrink: 0;
}

.sidebar-logo-link {
  display: flex;
  align-items: center;
}

.sidebar-logo {
  height: 30px;
  width: auto;
  filter: brightness(0) invert(1);
}

.sidebar-close {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.18s;
  flex-shrink: 0;
}

.close-x {
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #ffffff;
}

.sidebar-close:hover {
  background: rgba(255, 255, 255, 0.35);
}

/* ── User Strip ── */
.sidebar-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: #f8f9ff;
  border-bottom: 1px solid #e8edf8;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
}

.sidebar-user:hover {
  background: #eef2ff;
}

.sidebar-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #c7d6ff;
  flex-shrink: 0;
}

.sidebar-guest-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3467d5, #5b87f0);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sidebar-user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.sidebar-user-name {
  font-family: "Inter", sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-user-sub {
  font-family: "Inter", sans-serif;
  font-size: 11.5px;
  color: #6b7280;
}

.sidebar-user-arrow {
  flex-shrink: 0;
}

/* ── Section Label ── */
.sidebar-section-label {
  font-family: "Inter", sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 14px 18px 6px;
  flex-shrink: 0;
}

/* ── Category Menu ── */
.sidebar-menu {
  list-style: none;
  padding: 0 10px 8px;
  margin: 0;
  flex: 1;
}

.sidebar-item {
  font-size: 14.5px;
  padding: 11px 12px;
  border-radius: 9px;
  margin-bottom: 2px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Inter", sans-serif;
  color: #1f2937;
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
}

.sidebar-item:hover,
.sidebar-item-active {
  background: #eef2ff;
  color: #3467d5;
}

.sidebar-item-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sidebar-item-icon {
  width: 20px;
  height: 20px;
  color: #6b7280;
  flex-shrink: 0;
  transition: color 0.15s;
}

.sidebar-item:hover .sidebar-item-icon,
.sidebar-item-active .sidebar-item-icon {
  color: #3467d5;
}

.sidebar-arrow-icon {
  color: #9ca3af;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.sidebar-arrow-icon.rotated {
  transform: rotate(180deg);
  color: #3467d5;
}

/* ── Category Pills ── */
.sidebar-category-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 16px 16px;
}

.sidebar-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  color: #4b5563;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sidebar-pill:hover {
  border-color: #3467d5;
  color: #3467d5;
  background: #f0f4ff;
}

.sidebar-pill.active {
  background: linear-gradient(135deg, #3467d5 0%, #5b87f0 100%);
  border-color: #3467d5;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(52, 103, 213, 0.25);
}

.pill-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.sidebar-pill.active .pill-icon {
  stroke-width: 2.5;
}

/* ── Submenu List ── */
.sidebar-submenu-list {
  list-style: none;
  padding: 0 12px 12px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-submenu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 450;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
}

.sidebar-submenu-item:hover {
  background: #eff6ff;
  border-color: rgba(52, 103, 213, 0.3);
  color: #3467d5;
}

.submenu-icon {
  width: 16px;
  height: 16px;
  color: #9ca3af;
  flex-shrink: 0;
}

.sidebar-submenu-item:hover .submenu-icon {
  color: #3467d5;
}

.submenu-arrow {
  margin-left: auto;
  color: #9ca3af;
  flex-shrink: 0;
}

.sidebar-submenu-item:hover .submenu-arrow {
  color: #3467d5;
  transform: translateX(2px);
}

.sidebar-submenu {
  padding: 2px 0 6px 28px;
  list-style: none;
  background: transparent;
}

.sidebar-submenu li {
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  color: #4b5563;
  font-size: 13.5px;
  border-radius: 7px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s, color 0.15s;
}

.sidebar-submenu li:hover {
  background: #f0f4ff;
  color: #3467d5;
}

.submenu-bullet {
  font-size: 16px;
  color: #c7d6ff;
  line-height: 1;
  flex-shrink: 0;
}

/* ── Bottom Actions ── */
.sidebar-actions {
  padding: 12px 14px calc(24px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid #f0f1f5;
  flex-shrink: 0;
  background: #fafbff;
}

.sidebar-action-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  border-radius: 10px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.18s, transform 0.15s, box-shadow 0.18s;
  border: none;
  position: relative;
}

.sidebar-action-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.sidebar-action-message {
  background: linear-gradient(135deg, #1d3fa8 0%, #3467d5 60%, #5b87f0 100%);
  color: #ffffff;
  box-shadow: 0 3px 12px rgba(52, 103, 213, 0.30);
}

.sidebar-action-contact {
  background: #ffffff;
  color: #3467d5;
  border: 1.5px solid #c7d6ff;
  box-shadow: 0 1px 4px rgba(52, 103, 213, 0.08);
}

.sidebar-action-contact:hover {
  background: #f0f4ff;
  border-color: #3467d5;
}

.sidebar-msg-badge {
  position: absolute;
  top: -6px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: #ef4444;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: rgba(10, 15, 40, 0.50);
  z-index: 4000;
  backdrop-filter: blur(3px);
}

/* ══════════════════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════════════════ */
.desktop-only {
  display: block;
}

.hamburger {
  display: none;
  cursor: pointer;
}

.hamburger img {
  width: 24px;
  height: 24px;
}

@media (max-width: 1120px) {
  .nav-center {
    display: none;
  }
  .desktop-only {
    display: none !important;
  }
  .hamburger {
    display: block !important;
  }
  .navbar {
    padding: 0 24px;
  }
}

@media (max-width: 768px) {
  /* Slim navbar on mobile — saves 16px */
  .main-div {
    height: calc(56px + env(safe-area-inset-top, 0px));
  }
  /* Full-width under the 56px navbar; the copy stacks above the buttons so a
     narrow screen never squeezes the Sign in button. */
  .session-expired-toast {
    top: calc(66px + env(safe-area-inset-top, 0px));
    right: 12px;
    left: 12px;
    max-width: none;
    gap: 12px;
    flex-wrap: wrap;
  }
  .session-expired-copy {
    flex: 1 1 auto;
  }
  .session-expired-signin {
    flex: 1 1 100%;
    order: 3;
    padding: 10px 16px;
  }
  .desktop-only {
    display: none !important;
  }
  .hideMobile {
    display: none;
  }
  .hamburger {
    display: block;
  }
  .nav-message {
    display: none;
  }
  .contact-us {
    display: none;
  }
  .navbar {
    padding: 0 16px;
  }
  .nav-left {
    gap: 10px;
  }
  .logo-desktop { display: none; }
  .logo-mobile {
    display: block;
    width: 140px;
    height: 44px;
  }
  .nav-right {
    gap: 8px;
    flex: 1 1 auto;
    min-width: 0;
  }
  .post-btns {
    padding: 8px 12px;
    font-size: 12px;
    height: 36px;
    max-width: 44vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .avatar {
    width: 34px;
    height: 34px;
  }
  .avatar-wrapper {
    flex: 0 0 auto;
    padding-right: 0;
    margin-right: -2px;
  }
  .dropdown-position {
    top: calc(100% + 8px);
    right: 0;
  }
  .dropdown-position :deep(.profile-dropdown) {
    width: min(280px, calc(100vw - 24px));
    max-width: calc(100vw - 24px);
  }
  .dropdown-position :deep(.profile-info) {
    min-width: 0;
  }
  .dropdown-position :deep(.menu-item span) {
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

/* Responsive hiding for tight desktop widths. The navbar contents (logo +
   service menu + Message pill + Contact + Post Free Ad + avatar + username +
   CountrySelector when logged in) cannot all fit on smaller laptop viewports,
   so the optional buttons step out of the way as the viewport narrows.
     The AI search box is now hidden (v-if="false"), which frees ~264px, so the
     row fits at much smaller widths than before. With the search gone the full
     logged-in row fits once the viewport is >=1340px (was >=1600px when the
     ~264px search bar was present). Below that the nowrap row overflows and
     pushes the LAST item (CountrySelector + its dropdown) off the right edge.
     To guarantee the essential right group stays visible:
       >=1341px:    everything visible (Message pill included).
       1121-1340px: Message pill hidden so the avatar + CountrySelector group
                    always fits.
       <=768px:     mobile layout (handled elsewhere). */
/* AI search box is now hidden (v-if="false"), freeing ~264px in the row
   (240px max-width + 24px margin). That lets the Message pill stay visible on
   normal laptop widths: the threshold drops from 1600px to 1340px
   (1600 - 264 ≈ 1336, rounded to 1340). Below 1340px the pill still steps out
   to protect the avatar + CountrySelector group from overflow. */
/* Below the width where the full pill fits, the Message link goes icon-only
   rather than disappearing. It used to be display:none here, which meant a user
   at 110% zoom on a 1536px screen (≈1396 CSS px) simply lost the link. */
.nav-message-icon {
  display: none;
  width: 17px;
  height: 17px;
  color: var(--primary-color, #3467d5);
  flex-shrink: 0;
}

@media (min-width: 769px) and (max-width: 1440px) {
  .nav-message {
    padding: 6px 10px;
    margin-left: 0;
  }
  .nav-message-icon {
    display: block;
  }
  .nav-message-dot,
  .nav-message-label {
    display: none;
  }
  .nav-messagecount {
    margin-left: 2px;
  }
}

/* ── Laptop compaction ────────────────────────────────────────────────
   Measured intrinsic width of the desktop row: 1545px with the Message
   pill, 1384px without (logo 240 + 8 menu items + Message on the left;
   Contact + Post Free Ad + avatar + CountrySelector on the right, plus
   96px of navbar padding). .nav-left and .nav-right are both
   flex-shrink:0 in a nowrap row, so under that width the row does not
   compress — it overflows, and since App.vue sets
   html,body { overflow-x: hidden } the overflow is clipped rather than
   scrollable. The CountrySelector sits last on the right, so it is what
   silently disappears, and Message ends up flush against Contact with a
   0px gap just before it goes.

   Browser zoom is what puts people here: 90% on a 1280px display is
   1422 CSS px, and 90% on 1366px is 1517 — both inside the band where
   everything was still rendered at full size. Rather than one hard
   breakpoint, tighten spacing in two steps so the row fits instead of
   spilling. */
@media (min-width: 1121px) and (max-width: 1600px) {
  .navbar {
    padding-left: 28px;
    padding-right: 28px;
  }
  .nav-left {
    gap: 12px;
  }
  .logo {
    width: 210px;
    height: 49px;
  }
  .service-menu > li > p {
    padding: 6px 9px;
  }
  .deals-pill {
    padding: 6px 9px;
  }
  .contact-us {
    gap: 7px;
    padding: 6px 11px 6px 10px;
  }
  .post-btns {
    padding: 8px 14px;
  }
  .nav-right {
    gap: 6px;
  }
  .avatar-label {
    max-width: 72px;
  }
}

@media (min-width: 1121px) and (max-width: 1440px) {
  .navbar {
    padding-left: 16px;
    padding-right: 16px;
  }
  .logo {
    width: 180px;
    height: 42px;
  }
  .service-menu > li > p {
    padding: 6px 7px;
  }
  .deals-pill {
    padding: 6px 7px;
  }
  .avatar-label {
    max-width: 64px;
  }
}

/* Last squeeze, signed in only — that layout carries the CountrySelector and is
   still over at the bottom of the band. Signed out there is room to spare, and
   the same rules would hide the "Sign In" label for no reason.
   Runs to 1440 rather than 1240: keeping the Message link visible instead of
   hiding it costs ~72px, and this is where that comes from. */
@media (min-width: 1121px) and (max-width: 1440px) {
  .navbar-signed-in {
    padding-left: 12px;
    padding-right: 12px;
  }
  .navbar-signed-in .logo {
    width: 150px;
    height: 35px;
  }
  .navbar-signed-in .service-menu > li > p {
    padding: 6px 5px;
  }
  .navbar-signed-in .deals-pill {
    padding: 6px 5px;
  }
  .navbar-signed-in .avatar-label {
    display: none;
  }
  .navbar-signed-in :deep(.selected-country) {
    padding: 5px 7px;
  }
}

/* The narrowest desktop case, signed in: even with everything above trimmed,
   the row is ~85px over. Contact steps out here — it is one click away in the
   sidebar and the footer, whereas Messages is a primary destination carrying an
   unread count, and the CountrySelector cannot be dropped without silently
   changing which country's listings the user sees. */
@media (min-width: 1121px) and (max-width: 1240px) {
  .navbar-signed-in .contact-us {
    display: none;
  }
  .navbar-signed-in .service-menu > li > p {
    padding: 6px 4px;
  }
  .navbar-signed-in .deals-pill {
    padding: 6px 4px;
  }
}

/* Contact button restored on laptop widths (was hidden 1121-1600px to protect
   the CountrySelector from overflow). Kept visible from 769px up; only the
   Message pill still steps out below 1440px to free space. */

.nav-message-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

/* ── Nav Search Bar ────────────────────────────────────────── */
.nav-search {
  flex: 1 1 0;
  max-width: 240px;
  min-width: 160px;
  margin: 0 12px;
  position: relative;
}
.nav-search-input-wrap {
  display: flex;
  align-items: center;
  background: #f4f6fa;
  border: 1px solid #e0e4ec;
  border-radius: 10px;
  padding: 0 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.nav-search-input-wrap:focus-within {
  border-color: #3467d5;
  box-shadow: 0 0 0 3px rgba(52, 103, 213, 0.10);
}
.nav-search-ai-badge {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed, #3467d5);
  padding: 2px 6px;
  border-radius: 4px;
  letter-spacing: 0.5px;
  line-height: 1.3;
}
.nav-search-ai-spark {
  font-size: 16px;
  flex-shrink: 0;
}
.nav-search-icon {
  color: #9ca3af;
  flex-shrink: 0;
}
.nav-search-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  padding: 8px 6px;
  color: #1f2937;
  font-family: 'Inter', sans-serif;
  text-overflow: ellipsis;
}
.nav-search-input::placeholder {
  color: #9ca3af;
}
.nav-search-clear {
  border: none;
  background: none;
  color: #9ca3af;
  font-size: 18px;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
}
.nav-search-clear:hover {
  color: #374151;
}

/* Dropdown */
.nav-search-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid #e5e7eb;
  z-index: 9999;
  max-height: 320px;
  overflow-y: auto;
  padding: 6px 0;
}
.nav-search-group-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 14px 4px;
}
.nav-search-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
  transition: background 0.15s;
}
.nav-search-item:hover {
  background: #f0f4ff;
}
.nav-search-item-icon {
  color: #9ca3af;
  flex-shrink: 0;
}
.nav-search-item-type {
  margin-left: auto;
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
}
.nav-search-freetext {
  border-top: 1px solid #f0f0f0;
  color: #3467d5;
  font-weight: 500;
  background: linear-gradient(90deg, #f5f3ff, #eef2ff);
}
.nav-search-freetext:hover {
  background: linear-gradient(90deg, #ede9fe, #e0e7ff) !important;
}
.nav-search-freetext strong {
  color: #1f2937;
}

/* ── Sidebar Search ── */
.sidebar-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
}
.sidebar-search-input {
  flex: 1;
  min-width: 0;
  border: 1px solid #e0e4ec;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  outline: none;
  background: #f4f6fa;
}
.sidebar-search-input:focus {
  border-color: #3467d5;
}
.sidebar-search-btn {
  width: 38px;
  height: 38px;
  min-width: 38px;
  min-height: 38px;
  border-radius: 8px;
  border: none;
  background: #3467d5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  overflow: visible;
}
.sidebar-search-btn svg {
  display: block;
  flex-shrink: 0;
}
.sidebar-search-btn:hover {
  background: #2851b0;
}

@media (max-width: 1120px) {
  .nav-search {
    display: none;
  }
}

/* "More ▾" mega-dropdown */
.more-caret { font-size: 11px; opacity: 0.7; margin-left: 2px; }
.menu-wrapper-more { position: relative; }

/* Deals — clear (no button), flashing gradient text */
.menu-wrapper-deals { display: flex; align-items: center; }
.deals-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: transform 0.18s ease;
}
.deals-pill-icon {
  width: 19px;
  height: 19px;
  flex-shrink: 0;
  color: #ff5e62;
  animation: deals-flicker 2.4s ease-in-out infinite;
}
.deals-pill-text {
  background: linear-gradient(110deg, #ff9d2f 0%, #ff5e62 48%, #ff2e93 100%);
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: deals-flash 3.2s ease infinite;
}
.menu-wrapper-deals:hover .deals-pill { transform: translateY(-1px); }
@keyframes deals-flash {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
@keyframes deals-flicker {
  0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
  45%      { transform: scale(1.12) rotate(-4deg); opacity: 0.92; }
  70%      { transform: scale(0.96) rotate(3deg); opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .deals-pill-icon, .deals-pill-text { animation: none; }
}

.more-mega {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #ffffff;
  border: 1px solid #eef0f5;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12), 0 2px 10px rgba(0, 0, 0, 0.06);
  padding: 18px;
  width: 560px;
  z-index: 1000;
}
.service-mega {
  left: 0;
  right: auto;
  width: 520px;
}
.service-mega-narrow { width: 320px; }
.more-mega-grid.more-mega-grid-single { grid-template-columns: 1fr; }
.more-mega::before {
  content: "";
  position: absolute;
  top: -12px; left: 0; right: 0;
  height: 12px;
  background: transparent;
}
.more-mega-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 12px;
  padding: 0 4px;
}
.more-mega-eyebrow {
  font-size: 11px;
  font-weight: 700;
  color: #6c7793;
  letter-spacing: 0.8px;
}
.more-mega-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
}
/* Grouped sections for categories with a 3rd level (e.g. Real Estate):
   sub-category acts as a small clickable header above its serviceTypeInfo items. */
.more-mega-section + .more-mega-section { margin-top: 6px; }
.more-mega-section-title {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 6px 4px 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #6c7793;
  cursor: pointer;
  font-family: "Inter", -apple-system, sans-serif;
  transition: color 0.15s ease;
}
.more-mega-section-title:hover { color: #1f3987; }
.more-mega-item {
  display: flex;
  gap: 12px;
  padding: 11px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s;
  align-items: center;
}
.more-mega-item:hover { background: #f6f8fc; }
.more-mega-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex-shrink: 0;
}
.more-mega-icon svg { display: block; }
.more-mega-text { min-width: 0; }
.more-mega-label {
  font-size: 14px;
  font-weight: 600;
  color: #1c2540;
  line-height: 1.2;
  font-family: "Inter", -apple-system, sans-serif;
}
.more-mega-desc {
  font-size: 12px;
  color: #6c7793;
  line-height: 1.35;
  margin-top: 2px;
}
/* Mobile sidebar — leaf rows are visually subordinate to their sub-category:
   no card chrome, a nesting guide line, smaller muted text. */
.sidebar-submenu-leaf {
  margin-left: 18px;
  padding: 8px 12px 8px 16px;
  background: transparent;
  border: none;
  border-left: 2px solid #e2e8f0;
  border-radius: 0;
  font-size: 12.5px;
  font-weight: 400;
  color: #64748b;
}
.sidebar-submenu-leaf:hover {
  background: transparent;
  border-left-color: #3467d5;
  color: #3467d5;
}

/* Mobile sidebar — More section uses the same SVG icon language */
.sidebar-more-label { margin-top: 18px; }
.sidebar-more-item {
  align-items: center;
}
.sidebar-more-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 12px;
}
.sidebar-more-icon svg { display: block; }
.sidebar-more-text { flex: 1; min-width: 0; }
.sidebar-more-itemlabel {
  font-size: 14px;
  font-weight: 600;
  color: #1c2540;
  line-height: 1.2;
}
.sidebar-more-itemdesc {
  font-size: 11px;
  color: #6c7793;
  line-height: 1.3;
  margin-top: 2px;
}

/* Deals — splash card (echoes desktop flame/gradient treatment) */
.sidebar-deals-card {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 14px 12px 4px;
  padding: 14px 16px;
  border-radius: 14px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(115deg, #ffa62b 0%, #ff7a45 50%, #ff5e8a 100%);
  background-size: 200% 100%;
  box-shadow: 0 8px 22px rgba(255, 110, 90, 0.38);
  animation: sidebar-deals-gradient 6s ease infinite;
  -webkit-tap-highlight-color: transparent;
}
.sidebar-deals-card:active { transform: scale(0.985); }
.sidebar-deals-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  color: #fff3c4;
  background: rgba(255, 255, 255, 0.18);
  filter: drop-shadow(0 0 3px rgba(255, 224, 150, 0.5));
  animation: sidebar-deals-flicker 2.4s ease-in-out infinite;
}
.sidebar-deals-text { flex: 1; min-width: 0; position: relative; z-index: 1; }
.sidebar-deals-title { font-size: 15px; font-weight: 800; line-height: 1.2; }
.sidebar-deals-desc { font-size: 11.5px; color: rgba(255, 255, 255, 0.88); line-height: 1.3; margin-top: 2px; }
.sidebar-deals-arrow { flex-shrink: 0; color: rgba(255, 255, 255, 0.92); }
.sidebar-deals-shine {
  position: absolute;
  top: 0;
  left: -60%;
  width: 45%;
  height: 100%;
  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.45), transparent);
  transform: skewX(-20deg);
  animation: sidebar-deals-shine 3.6s ease-in-out infinite;
}
@keyframes sidebar-deals-gradient {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
@keyframes sidebar-deals-shine {
  0%   { left: -60%; }
  55%  { left: 120%; }
  100% { left: 120%; }
}
@keyframes sidebar-deals-flicker {
  0%, 100% { transform: scale(1) rotate(0deg); }
  45%      { transform: scale(1.1) rotate(-4deg); }
  70%      { transform: scale(0.97) rotate(3deg); }
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-deals-card, .sidebar-deals-icon, .sidebar-deals-shine { animation: none; }
}
</style>
